import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy,Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardActions,MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { forkJoin } from 'rxjs';

import { AdminComponentBase } from 'app/layout/content/admin-component-base';
import { PageSimpleContentComponent } from 'app/layout/content/page-simple-content.component';
import { ErrorComponent } from 'app/shared/components/error.component';
import { EnableRequestLoggerInput, RequestLog, RequestLoggingConfiguration } from 'app/shared/graph';
import { CopyToClipboardComponent } from 'app/shared/utilities/copy-to-clipboard.component';
import { FromNowPipe } from 'app/shared/utilities/from-now.pipe';

import { AddRequestLoggerRuleDialogComponent } from './add-request-logger-rule-dialog.component';
import { RequestLoggerService } from './request-logger.service';

@Component({
    templateUrl: './request-logger-page.component.html',
    styleUrls: ['./request-logger-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PageSimpleContentComponent, ErrorComponent, MatButton, MatIcon, MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatFormField, MatLabel, MatInput, FormsModule, MatSuffix, MatDivider, CopyToClipboardComponent, MatCardActions, DatePipe, FromNowPipe]
})
export class RequestLoggerPageComponent extends AdminComponentBase implements OnInit, OnDestroy {
    private readonly requestLoggerService = inject(RequestLoggerService);
    private readonly dialog = inject(MatDialog);

    readonly appNames: Readonly<string[]> = ['HubApi', 'Ecb', 'Render', 'Photos'];
    configurationsByAppName: Record<string, RequestLoggingConfiguration> = {};
    logsPerRuleId: Record<string, RequestLog[]> = {};

    ngOnInit(): void {
        this.loadRules();
    }

    loadRules() {
        this.subscribeWithGenericLoadingErrorHandling(
            forkJoin(this.appNames.map(appName => this.requestLoggerService.loadRequestLoggerConfiguration(appName))),
            (configurations: RequestLoggingConfiguration[]): void => {
                for (let i = 0; i < this.appNames.length; i++) {
                    this.configurationsByAppName[this.appNames[i]] = configurations[i];
                    for (let rule of configurations[i].rules)
                        this.loadLogs(rule.id)
                }
            });
    }

    ngOnDestroy(): void {
        this.unsubscribeSubscriptions();
    }

    addNewRule(appName: string) {
        let dialogRef = this.dialog.open<AddRequestLoggerRuleDialogComponent, any, EnableRequestLoggerInput>(AddRequestLoggerRuleDialogComponent);
        dialogRef.afterClosed().subscribe((result) => {
            if (!result) {
                return;
            }
            if (!result.storeId)
                result.storeId = undefined;
            if (!result.statusCode)
                result.statusCode = undefined;
            if (!result.logsExpirationInSeconds)
                result.logsExpirationInSeconds = undefined;
            if (!result.maximumCaptureCount)
                result.maximumCaptureCount = undefined;
            this.subscribeWithGenericSavingErrorHandling(this.requestLoggerService.enableRequestLogger(appName, result), () => {
                this.loadRules()
            })
        });
    }

    deleteRule(appName: string, ruleId: string) {
        this.subscribeWithGenericSavingErrorHandling(this.requestLoggerService.disableRequestLogger(appName, ruleId), () => {
            this.loadRules()
        })

    }

    loadLogs(ruleId: string) {
        this.requestLoggerService.loadRequestLogs(ruleId).subscribe((logs) => {
            this.logsPerRuleId[ruleId] = logs
        });
    }
}
